import { db } from "../firebase";
import {
  collection,
  getDocs,
  doc,
  getDoc,
  setDoc,
  updateDoc
} from "firebase/firestore";

/**
 * Ajuste manual por ID interno:
 * Se o idInterno existir na categoria do modo, SOMA:
 * - deltaPontos em categoria.pontos
 * - deltaPontos em modo.pontosmodo
 * - deltaPercent em modo.porcentagem
 * Depois recalcula totalPontos e atualiza:
 * - usuarios/{uid}.pontuacao
 * - ranking/usuarios/{uid}/pontos
 *
 * Não mexe em acertou (você já corrigiu por flag).
 */
export async function ajusteManualPorId({
  modo,
  tipo,
  categoriaId,
  idInterno,
  deltaPontos = 0,
  deltaPercent = 0
}) {
  if (!modo || !tipo || !categoriaId || !idInterno) {
    console.warn("Parâmetros insuficientes em ajusteManualPorId", {
      modo, tipo, categoriaId, idInterno
    });
    return;
  }

  const modoFinal = modo.includes("-") ? modo : `${modo}-${tipo}`;
  const alvo = String(idInterno).trim();
  const dPontos = Number(deltaPontos) || 0;
  const dPercent = Number(deltaPercent) || 0;

  console.log("🧾 Ajuste manual (início)", { modoFinal, categoriaId, alvo, dPontos, dPercent });

  const usuariosSnap = await getDocs(collection(db, "usuarios"));

  let afetados = 0;
  let ignorados = 0;

  for (const usuarioDoc of usuariosSnap.docs) {
    const uid = usuarioDoc.id;

    const docDadosRef = doc(db, `usuarios/${uid}/snapDropdown2026/dados`);
    const docDadosSnap = await getDoc(docDadosRef);
    if (!docDadosSnap.exists()) {
      ignorados++;
      continue;
    }

    const dadosTudo = docDadosSnap.data() || {};
    const dadosModo = dadosTudo[modoFinal];
    if (!dadosModo || typeof dadosModo !== "object") {
      ignorados++;
      continue;
    }

    const categoria = dadosModo[categoriaId];
    if (!categoria || typeof categoria !== "object") {
      ignorados++;
      continue;
    }

    // 1) checar se o ID existe em qualquer posição da categoria
    let existe = false;
    for (const [pos, dados] of Object.entries(categoria)) {
      if (pos === "dataAtualizacao" || pos === "pontos") continue;
      if (!dados || typeof dados !== "object") continue;

      const id = String(dados.idInterno || "").trim();
      if (id && id === alvo) {
        existe = true;
        break;
      }
    }

    if (!existe) {
      ignorados++;
      continue;
    }

    // 2) SOMAR pontos na categoria
    const pontosCategoriaAtual = Number(categoria.pontos) || 0;
    const categoriaAtualizada = {
      ...categoria,
      pontos: pontosCategoriaAtual + dPontos
    };

    // 3) SOMAR pontos no modo
    const pontosModoAtual = Number(dadosModo.pontosmodo) || 0;

    // 4) SOMAR porcentagem no modo (campo é string)
    const porcentAtual = Number(String(dadosModo.porcentagem || "0").replace(",", ".")) || 0;
    const novaPorcent = porcentAtual + dPercent;

    const modoAtualizado = {
      ...dadosModo,
      [categoriaId]: categoriaAtualizada,
      pontosmodo: pontosModoAtual + dPontos,
      porcentagem: novaPorcent.toFixed(1),
    };

    // grava só o modo atualizado (cirúrgico)
    await setDoc(docDadosRef, { [modoFinal]: modoAtualizado }, { merge: true });

    // 5) Recalcular total + ranking (igual parte 2 do dropdown)
    const docReSnap = await getDoc(docDadosRef);
    const dadosRe = docReSnap.data() || {};

    let total = 0;
    const dadosSnapshot = {};

    for (const [chave, valor] of Object.entries(dadosRe)) {
      if (chave === "totalPontos") continue;
      if (!valor || typeof valor !== "object") continue;

      const porcentagem = valor.porcentagem || "0.0";
      const ultimaAtualizacao = valor.ultimaAtualizacao || null;
      const pontosmodo = valor.pontosmodo || 0;

      dadosSnapshot[chave] = { porcentagem, ultimaAtualizacao, pontosmodo };

      for (const cat of Object.keys(valor)) {
        if (!cat.startsWith("melhor")) continue;

        const catObj = valor[cat];
        if (!catObj || typeof catObj !== "object") continue;

        const pontosCat = Number(catObj.pontos) || 0;
        dadosSnapshot[chave][cat] = { pontos: pontosCat };
        total += pontosCat;
      }
    }

    dadosSnapshot.total = total;

    await setDoc(docDadosRef, { totalPontos: total }, { merge: true });
    await updateDoc(doc(db, `usuarios/${uid}`), { pontuacao: total });
    await setDoc(doc(db, `ranking/usuarios/${uid}/pontos`), dadosSnapshot);

    afetados++;
    console.log(`✅ Ajuste aplicado: ${uid} (${modoFinal}/${categoriaId})`, { dPontos, dPercent });
  }

  console.log("🧾 Ajuste manual (fim)", { afetados, ignorados });
  return { afetados, ignorados };
}
